import React from 'react';

interface BookComponentProps {
  title: string;
  subtitle: string;
  imageSrc: string;
  description: string[];
  buyUrl: string;
}

const BookComponent: React.FC<BookComponentProps> = ({
  title,
  subtitle,
  imageSrc,
  description,
  buyUrl,
}) => {
  return (
    <div className="bookCard">
      <div className="bookImageContainer">
        <img
          alt={title}
          className="bookImage"
          src={imageSrc}
        />
      </div>

      <div className="bookContent">
        <h2 id={title} className="bookHeader">{title}</h2>
        <h3 className="bookSubHeader">{subtitle}</h3>

        {description.map((paragraph, i) => (
          <p key={i} className="bookDetail">{paragraph}</p>
        ))}

        <div className="bookFooter">
          <a href={buyUrl} target="_blank" rel="noopener noreferrer">
            <img
              alt={`Buy ${title} on Amazon`}
              src="images/buy-on-amazon-button.png"
              className="buyButton"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default BookComponent;
